import { Box } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { Search } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useResultsPageContext } from './ResultsPageContext';
import { useResultsSearchBarV4Layouts, V4_SEARCH_BAR_PLACEHOLDER_KEY } from './resultsSearchBarV4Layouts';
import { StatusSlot } from './StatusSlot';
export const ResultsSearchBar = _ref => {
  let {
    onSearchSubmit,
    isWixHpMobile = false,
    showUnassignedDomainsOnEmptyInput = false,
    compactLayouts = false
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const {
    emptyQueryStatus,
    updateUrl,
    showSearchIcon,
    hideFilterChips
  } = useResultsPageContext();
  const v4Layouts = useResultsSearchBarV4Layouts();
  const useV4Layouts = compactLayouts && !isMobile;
  const isV4Mobile = compactLayouts && isMobile;
  const mobilePlaceholder = isWixHpMobile ? t('domains_search_gate.anon.results.empty_state.searchbar.placeholder') : t('domains-search-suite-translations-ns:DomainSearch.Mobile.searchInput.placeholder');
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    compact: true,
    showSearchIcon: showSearchIcon && !isMobile,
    submitIcon: isWixHpMobile ? /*#__PURE__*/React.createElement(Box, {
      verticalAlign: "middle",
      align: "center",
      scale: "1.3"
    }, /*#__PURE__*/React.createElement(Search, {
      color: "white"
    })) : isV4Mobile ? /*#__PURE__*/React.createElement(Search, {
      color: "white"
    }) : undefined,
    emphasized: isWixHpMobile,
    hideClearButton: isWixHpMobile || compactLayouts,
    hideFilters: hideFilterChips,
    showOptionsIfEmptyInput: showUnassignedDomainsOnEmptyInput,
    hideUnassignedDomains: !showUnassignedDomainsOnEmptyInput,
    autoFocus: isWixHpMobile,
    useModalToolbar: isMobile,
    placeholder: useV4Layouts ? t(V4_SEARCH_BAR_PLACEHOLDER_KEY) : isMobile ? mobilePlaceholder : undefined,
    onSubmit: filters => {
      updateUrl(filters);
      onSearchSubmit == null || onSearchSubmit(filters);
    },
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    },
    Layouts: {
      ...(useV4Layouts && v4Layouts),
      StatusComponent: () => /*#__PURE__*/React.createElement(StatusSlot, {
        emptyQueryStatus: emptyQueryStatus
      })
    }
  });
};
//# sourceMappingURL=ResultsSearchBar.js.map